
// src/utils/bibtexParser.js
import React from 'react'; // Import React to use JSX
import { BibtexParser } from 'bibtex-js-parser';
import '../styles/PublicationsPage.css';

/**
 * Parses a BibTeX string and returns the parsed JSON.
 * @param {string} bibtexString - The BibTeX data as a string.
 * @returns {Object[]|null} The parsed BibTeX data, or null on error.
 */
export function parseBibtexString(bibtexString) {
    try {
        // console.log("Raw BibTeX Input:", bibtexString); // Verifica la entrada cruda
        const parsed = BibtexParser.parseToJSON(bibtexString);
        // console.log("Parsed BibTeX Output:", parsed); // Verifica la salida procesada
        return parsed;
    } catch (error) {
        console.error("Error parsing BibTeX:", error); // Captura errores
        return null;
    }
}



/**
 * Renders a publication's details in a structured format.
 * @param {Object} pub - A single publication entry.
 * @param {Function} onShowBibtex - Callback function to handle displaying BibTeX.
 * @returns {JSX.Element} JSX structure displaying the publication.
 */
export function displayPaper(pub, onShowBibtex) {
    return (
        <div className="pub-card">
            <h3 className="paper-title">
                {pub.url ? (
                    <a href={pub.url} target="_blank" rel="noopener noreferrer" className="pub-link">
                        {pub.title}
                    </a>
                ) : (
                    pub.title
                )}
            </h3>
            <p><strong>Author(s):</strong> {pub.author}</p>
            <p><strong>Source:</strong> {pub.journal || pub.booktitle || pub.conference || pub.publisher || pub.archivePrefix || "Unknown"}</p>
            {pub.archive && <p><strong>Archive:</strong> {pub.archive}</p>}
            <button className="show-bibtex" onClick={() => onShowBibtex(pub.bibtex)}>Show BibTeX</button> {/* Button to open modal */}
        </div>
    );
}


/**
 * Reconstructs a BibTeX entry from a publication object.
 * @param {Object} pub - The publication object.
 * @returns {string} The reconstructed BibTeX entry.
 */
export function reconstructBibtex(pub) {
    let bibtex = `@${pub.type}{${pub.id},\n`;
    bibtex += `  title={${pub.title}},\n`;
    bibtex += `  author={${pub.author}},\n`;
    if (pub.year) bibtex += `  year={${pub.year}},\n`;
    if (pub.journal) bibtex += `  journal={${pub.journal}},\n`;
    if (pub.booktitle) bibtex += `  booktitle={${pub.booktitle}},\n`;
    if (pub.volume) bibtex += `  volume={${pub.volume}},\n`;
    if (pub.pages) bibtex += `  pages={${pub.pages}},\n`;
    if (pub.url) bibtex += `  url={${pub.url}},\n`;
    if (pub.eprint) bibtex += `  eprint={${pub.eprint}},\n`;
    if (pub.archivePrefix) bibtex += `  archivePrefix={${pub.archivePrefix}},\n`;
    if (pub.primaryClass) bibtex += `  primaryClass={${pub.primaryClass}},\n`;
    
    // Remove the last comma and newline, then add closing brace
    bibtex = bibtex.trim().replace(/,$/, '') + '\n}\n';

    return bibtex;
}

